import React, { useEffect, useState } from "react";
import { Layout, Modal, Typography, Spin, message } from "antd";
import axios from "../../services/axiosInstance";
import { useLocation, useParams } from "react-router-dom";
import { FETCH_SIGNED_DOCUMENT_FROM_EMAIL } from "../../services/apiEndPoints";

const { Title } = Typography;


export const isPdf = (url: string) => {
    return url.toLowerCase().includes(".pdf");
};

const DocumentSingleComponent: React.FC = () => {
    const params = useParams();
    const documentId = params.id;
    const [signedUrl, setSignedUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const fetchSignedUrl = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                FETCH_SIGNED_DOCUMENT_FROM_EMAIL(documentId || "")
            );

            if (response?.data?.results) {
                setSignedUrl(response.data.results);
            } else {
                throw new Error("Invalid response");
            }
        } catch (error) {
            message.error("Failed to load document");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (documentId) {
            fetchSignedUrl();
        } else {
            message.error("No document ID provided");
        }
    }, [documentId]);

    return (

        <Layout style={{ background: "transparent", textAlign: "center" }}>
            {loading && <Spin size="large" />}

            {!loading && signedUrl && isPdf(signedUrl) && (
                <iframe
                    src={signedUrl}
                    width="100%"
                    style={{ height: "85vh", border: "none" }}
                    title="PDF Preview"
                />
            )}

            {!loading && signedUrl && !isPdf(signedUrl) && (
                <img
                    src={signedUrl}
                    alt="Document Preview"
                    style={{
                        maxWidth: "100%",
                        maxHeight: "85vh",
                        objectFit: "contain",
                        display: "block",
                        margin: "0 auto",
                    }}
                />
            )}
        </Layout>

    );
};

export default DocumentSingleComponent;
